/* src/app/self-enrollment/pdf/terms-long/termsLongPdf.component.css */
* {
  margin: 0;
  padding: 0;
  text-indent: 0;
}
h1 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 20pt;
}
.s1 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 14pt;
}
.s2 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: italic;
  font-weight: normal;
  text-decoration: none;
  font-size: 14pt;
}
.s3 {
  color: #FFF;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 10pt;
}
.s4 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 10pt;
}
.s5 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 10pt;
}
.s6 {
  color: #0462C1;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: underline;
  font-size: 10pt;
}
p {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 10pt;
  margin: 0pt;
}
.a,
a {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 10pt;
}
.s8 {
  color: #0462C1;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: underline;
  font-size: 10pt;
}
table,
tbody {
  vertical-align: top;
  overflow: visible;
}
/*# sourceMappingURL=termsLongPdf.component.css.map */
